import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Turborepo 1.6",
  "description": "Turborepo 1.6을 사용하면 모노레포가 아닌 환경에서 Turborepo를 사용하고, npm용 prune을 제공하며, 캐시 성능을 개선합니다.",
  "date": "2022/10/21",
  "tag": "web development"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo 1.6은 Turborepo의 게임을 바꿉니다 - 이제 모든 프로젝트에서 사용할 수 있습니다."
  }, {
    "heading": "",
    "content": "모노레포가 아닌 환경의 Turborepo: 프로젝트에서 느린 빌드를 경험하고 있나요? 이제 package.json이 있는 모든 코드베이스에서 Turborepo를 사용하여 빌드 속도를 높일 수 있습니다."
  }, {
    "heading": "",
    "content": "turbo prune이 이제 npm을 지원합니다: 이제 npm을 사용하는 모노레포에서 모노레포 프루닝이 지원되어 모든 주요 워크스페이스 관리자에 대한 지원이 완료되었습니다."
  }, {
    "heading": "",
    "content": "더 빠른 캐싱: 로컬 파일 쓰기 처리 방식을 개선하여 Turborepo 캐시의 속도를 크게 향상시켰습니다."
  }, {
    "heading": "",
    "content": "npm install turbo@latest를 실행하여 오늘 업데이트하세요."
  }, {
    "heading": "모든-코드베이스에서-turborepo-사용-가능",
    "content": "Turborepo는 코드베이스의 작업 속도를 높이는 데 도움을 줍니다. 지금까지 우리는 여러 애플리케이션과 패키지를 포함하는 코드베이스인 모노레포를 위해 Turborepo를 특별히 구축했습니다."
  }, {
    "heading": "모든-코드베이스에서-turborepo-사용-가능",
    "content": "Turborepo는 처리해야 할 작업이 많기 때문에 모노레포에서 환상적입니다. 각 패키지와 앱은 빌드, 린트 및 테스트가 필요합니다."
  }, {
    "heading": "모든-코드베이스에서-turborepo-사용-가능",
    "content": "그러나 우리는 생각했습니다: 모노레포가 아닌 많은 코드베이스도 많은 작업을 실행합니다. 대부분의 CI/CD 프로세스는 캐시의 이점을 누릴 수 있는 중복 작업을 많이 수행합니다."
  }, {
    "heading": "모든-코드베이스에서-turborepo-사용-가능",
    "content": "따라서 이제 모든 코드베이스에서 Turborepo를 사용할 수 있다는 것을 발표하게 되어 기쁩니다."
  }, {
    "heading": "모든-코드베이스에서-turborepo-사용-가능",
    "content": "예제에서 시작하거나 기존 프로젝트에 Turborepo를 추가하여 지금 사용해 보세요:"
  }, {
    "heading": "프로젝트에-turborepo-추가",
    "content": "turbo 설치:"
  }, {
    "heading": "프로젝트에-turborepo-추가",
    "content": "새 저장소의 기본 경로에 turbo.json 파일 추가:"
  }, {
    "heading": "프로젝트에-turborepo-추가",
    "content": "일부 Vite 스타터는 다음과 같은 package.json과 함께 제공됩니다:"
  }, {
    "heading": "프로젝트에-turborepo-추가",
    "content": "이를 lint 및 build 스크립트로 분할하는 것이 좋습니다."
  }, {
    "heading": "프로젝트에-turborepo-추가",
    "content": "이렇게 하면 turbo가 별도로 스케줄링할 수 있습니다."
  }, {
    "heading": "프로젝트에-turborepo-추가",
    "content": "turbo로 build 및 lint 실행 시도:"
  }, {
    "heading": "프로젝트에-turborepo-추가",
    "content": "축하합니다 - turbo로 첫 번째 빌드를 실행했습니다. 다음을 시도할 수 있습니다:"
  }, {
    "heading": "프로젝트에-turborepo-추가",
    "content": "전체 빠른 시작을 실행합니다."
  }, {
    "heading": "프로젝트에-turborepo-추가",
    "content": "Turborepo를 특별하게 만드는 요소를 이해하려면 업데이트된 핵심 개념 문서를 확인하세요."
  }, {
    "heading": "언제-turborepo를-사용해야-하나요",
    "content": "모노레포가 아닌 환경에서 Turborepo를 사용할 수 있게 되면서 많은 새로운 사용 사례가 열렸습니다. 그러나 언제 가장 좋을까요?"
  }, {
    "heading": "스크립트가-서로-의존할-때",
    "content": "turbo를 사용하여 package.json 스크립트를 실행해야 합니다. 서로 의존하는 여러 스크립트가 있는 경우 Turborepo 작업으로 표현할 수 있습니다:"
  }, {
    "heading": "스크립트가-서로-의존할-때",
    "content": "그런 다음 다음을 실행할 수 있습니다:"
  }, {
    "heading": "스크립트가-서로-의존할-때",
    "content": "lint 및 test 전에 build를 실행해야 한다고 말했기 때문에 lint 또는 test를 실행할 때 자동으로 build를 실행합니다."
  }, {
    "heading": "스크립트가-서로-의존할-때",
    "content": "뿐만 아니라 최적의 스케줄을 알아냅니다. 속도 최적화에 대한 핵심 개념 문서를 참조하세요."
  }, {
    "heading": "작업을-병렬로-실행하려는-경우",
    "content": "Next.js 앱을 실행하고 Tailwind CLI도 실행한다고 상상해보세요. dev 및 dev:css라는 두 개의 스크립트가 있을 수 있습니다:"
  }, {
    "heading": "작업을-병렬로-실행하려는-경우",
    "content": "turbo.json에 아무것도 추가하지 않고도 다음을 실행할 수 있습니다:"
  }, {
    "heading": "작업을-병렬로-실행하려는-경우",
    "content": "concurrently와 같은 도구처럼 Turborepo는 자동으로 두 스크립트를 병렬로 실행합니다."
  }, {
    "heading": "작업을-병렬로-실행하려는-경우",
    "content": "이것은 개발 모드에 매우 유용하지만 CI에서 작업 속도를 높이는 데도 사용할 수 있습니다 - 실행할 여러 스크립트가 있다고 상상해보세요:"
  }, {
    "heading": "작업을-병렬로-실행하려는-경우",
    "content": "Turborepo는 모든 작업을 병렬로 실행하는 가장 빠른 방법을 알아냅니다."
  }, {
    "heading": "npm에서-이제-prune-지원",
    "content": "지난 몇 번의 릴리스에 걸쳐 다양한 워크스페이스 관리자에서 turbo prune에 대한 지원을 추가해 왔습니다. 이것은 어려운 작업이었습니다 - turbo prune은 lockfile의 종속성 프루닝을 포함하여 모노레포의 하위 집합을 만듭니다. 이는 각 워크스페이스 관리자에 대해 별도로 로직을 구현해야 함을 의미했습니다."
  }, {
    "heading": "npm에서-이제-prune-지원",
    "content": "turbo prune이 이제 npm에서 작동한다는 것을 발표하게 되어 기쁩니다. 이로써 모든 주요 패키지 관리자에 대한 지원이 완료되었습니다. 즉, 모노레포가 npm, yarn, yarn 2+ 또는 pnpm을 사용하는 경우 Docker에 쉽게 배포할 수 있습니다."
  }, {
    "heading": "npm에서-이제-prune-지원",
    "content": "자세한 내용은 turbo prune에 대한 이전 블로그를 확인하세요."
  }, {
    "heading": "캐시의-성능-개선",
    "content": "1.6 이전에는 Turborepo의 로컬 캐시가 시스템의 파일을 디스크의 다른 위치로 재귀적으로 복사하는 방식이었습니다. 이것은 느렸습니다. 캐시해야 하는 모든 파일에 대해 6번의 시스템 호출을 수행해야 했습니다: 소스 파일에서 열기, 읽기 및 닫기; 대상 파일에서 열기, 쓰기 및 닫기."
  }, {
    "heading": "캐시의-성능-개선",
    "content": "1.6에서는 이를 거의 절반으로 줄였습니다. 이제 캐시를 만들 때 단일 .tar 파일(하나의 열기)을 만들고, 1mb 청크로 쓰고(배치 쓰기), 닫습니다(하나의 닫기). 시스템 호출의 절반은 캐시에서 나오는 방식에서도 발생합니다."
  }, {
    "heading": "캐시의-성능-개선",
    "content": "그리고 여기서 멈추지 않았습니다. 지난 한 달 동안 C로 작성된 최고 수준의 라이브러리 사용을 가능하게 하는 CGO를 활성화하기 위해 빌드 도구 체인에 상당한 투자를 했습니다. 이를 통해 압축을 위해 Zstandard의 libzstd를 채택할 수 있었으며, 이는 압축에 대한 알고리즘 3배 성능 향상을 제공합니다."
  }, {
    "heading": "캐시의-성능-개선",
    "content": "이러한 모든 변경 사항 이후 로컬 캐시 생성에서 2배 이상, 원격 캐시 생성에서 3배 이상의 성능 향상을 정기적으로 확인하고 있습니다. 이는 저장소가 클수록 또는 장치가 느릴수록(CI를 보고 있습니다) 더욱 좋아집니다. 이는 가장 필요로 하는 사람들에게 정확하게 성능 향상을 제공할 수 있었음을 의미합니다."
  }],
  "headings": [{
    "id": "모든-코드베이스에서-turborepo-사용-가능",
    "content": "모든 코드베이스에서 Turborepo 사용 가능"
  }, {
    "id": "프로젝트에-turborepo-추가",
    "content": "프로젝트에 Turborepo 추가"
  }, {
    "id": "언제-turborepo를-사용해야-하나요",
    "content": "언제 Turborepo를 사용해야 하나요?"
  }, {
    "id": "스크립트가-서로-의존할-때",
    "content": "스크립트가 서로 의존할 때"
  }, {
    "id": "작업을-병렬로-실행하려는-경우",
    "content": "작업을 병렬로 실행하려는 경우"
  }, {
    "id": "npm에서-이제-prune-지원",
    "content": "npm에서 이제 Prune 지원"
  }, {
    "id": "캐시의-성능-개선",
    "content": "캐시의 성능 개선"
  }]
};
import {Tabs, Tab} from '#components/tabs';
import {Authors} from '../../components/authors';
import {Date} from '../../components/blog/date';
import {Callout} from '../../components/callout';
export const toc = [{
  depth: 2,
  url: "#모든-코드베이스에서-turborepo-사용-가능",
  title: _jsx(_Fragment, {
    children: "모든 코드베이스에서 Turborepo 사용 가능"
  })
}, {
  depth: 3,
  url: "#프로젝트에-turborepo-추가",
  title: _jsx(_Fragment, {
    children: "프로젝트에 Turborepo 추가"
  })
}, {
  depth: 2,
  url: "#언제-turborepo를-사용해야-하나요",
  title: _jsx(_Fragment, {
    children: "언제 Turborepo를 사용해야 하나요?"
  })
}, {
  depth: 3,
  url: "#스크립트가-서로-의존할-때",
  title: _jsx(_Fragment, {
    children: "스크립트가 서로 의존할 때"
  })
}, {
  depth: 3,
  url: "#작업을-병렬로-실행하려는-경우",
  title: _jsx(_Fragment, {
    children: "작업을 병렬로 실행하려는 경우"
  })
}, {
  depth: 2,
  url: "#npm에서-이제-prune-지원",
  title: _jsx(_Fragment, {
    children: "npm에서 이제 Prune 지원"
  })
}, {
  depth: 2,
  url: "#캐시의-성능-개선",
  title: _jsx(_Fragment, {
    children: "캐시의 성능 개선"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    h3: "h3",
    li: "li",
    ol: "ol",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx("h1", {
      className: "text-center",
      children: "Turborepo 1.6"
    }), "\n", "\n", _jsx(Date, {
      children: "Friday, October 21st, 2022"
    }), "\n", _jsx(Authors, {
      authors: ['mattpocock', 'gregsoltis', 'nathanhammond', 'tomknickman', 'anthonyshew', 'jaredpalmer', 'mehulkar', 'chrisolszewski']
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 1.6은 Turborepo의 게임을 바꿉니다 - 이제 ", _jsx(_components.strong, {
        children: "모든 프로젝트"
      }), "에서 사용할 수 있습니다."]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#any-codebase-can-use-turborepo",
          children: _jsx(_components.strong, {
            children: "모노레포가 아닌 환경의 Turborepo"
          })
        }), ": 프로젝트에서 느린 빌드를 경험하고 있나요? 이제 ", _jsx(_components.code, {
          children: "package.json"
        }), "이 있는 모든 코드베이스에서 Turborepo를 사용하여 빌드 속도를 높일 수 있습니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#prune-now-supported-on-npm",
          children: _jsxs(_components.strong, {
            children: [_jsx(_components.code, {
              children: "turbo prune"
            }), "이 이제 npm을 지원합니다"]
          })
        }), ": 이제 ", _jsx(_components.code, {
          children: "npm"
        }), "을 사용하는 모노레포에서 모노레포 프루닝이 지원되어 모든 주요 워크스페이스 관리자에 대한 지원이 완료되었습니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#performance-improvements-in-the-cache",
          children: _jsx(_components.strong, {
            children: "더 빠른 캐싱"
          })
        }), ": 로컬 파일 쓰기 처리 방식을 개선하여 Turborepo 캐시의 속도를 크게 향상시켰습니다."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "npm install turbo@latest"
      }), "를 실행하여 오늘 업데이트하세요."]
    }), "\n", _jsx(_components.h2, {
      id: "모든-코드베이스에서-turborepo-사용-가능",
      children: "모든 코드베이스에서 Turborepo 사용 가능"
    }), "\n", _jsx(_components.p, {
      children: "Turborepo는 코드베이스의 작업 속도를 높이는 데 도움을 줍니다. 지금까지 우리는 여러 애플리케이션과 패키지를 포함하는 코드베이스인 모노레포를 위해 Turborepo를 특별히 구축했습니다."
    }), "\n", _jsx(_components.p, {
      children: "Turborepo는 처리해야 할 작업이 많기 때문에 모노레포에서 환상적입니다. 각 패키지와 앱은 빌드, 린트 및 테스트가 필요합니다."
    }), "\n", _jsxs(_components.p, {
      children: ["그러나 우리는 생각했습니다: 모노레포가 ", _jsx(_components.em, {
        children: "아닌"
      }), " 많은 코드베이스도 많은 작업을 실행합니다. 대부분의 CI/CD 프로세스는 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/caching",
        children: "캐시"
      }), "의 이점을 누릴 수 있는 중복 작업을 많이 수행합니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["따라서 ", _jsx(_components.strong, {
        children: "이제 모든 코드베이스에서 Turborepo를 사용할 수 있다"
      }), "는 것을 발표하게 되어 기쁩니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://github.com/vercel/turbo/tree/main/examples/non-monorepo",
        children: "예제에서 시작"
      }), "하거나 기존 프로젝트에 Turborepo를 추가하여 지금 사용해 보세요:"]
    }), "\n", _jsx(_components.h3, {
      id: "프로젝트에-turborepo-추가",
      children: "프로젝트에 Turborepo 추가"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: _jsxs(_components.strong, {
          children: [_jsx(_components.code, {
            children: "turbo"
          }), " 설치:"]
        })
      }), "\n"]
    }), "\n", _jsxs(Tabs, {
      items: ["npm", "yarn", "pnpm"],
      id: "selected-pkg-manager",
      children: [_jsx(Tab, {
        value: "npm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " install"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --save-dev"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "yarn"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " add"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --dev"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "pnpm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "pnpm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " add"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --save-dev"
                })]
              })
            })
          })
        })
      })]
    }), "\n", _jsxs(_components.ol, {
      start: "2",
      children: ["\n", _jsx(_components.li, {
        children: _jsxs(_components.strong, {
          children: ["새 저장소의 기본 경로에 ", _jsx(_components.code, {
            children: "turbo.json"
          }), " 파일 추가:"]
        })
      }), "\n"]
    }), "\n", _jsxs(Tabs, {
      items: ['Next.js', 'Vite'],
      storageKey: "framework-preference",
      children: [_jsx(Tab, {
        value: "Next.js",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./turbo.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"pipeline\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"outputs\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\".next/**\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"!.next/cache/**\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"lint\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"outputs\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " []"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsxs(Tab, {
        value: "Vite",
        children: [_jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./turbo.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"pipeline\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"outputs\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"dist/**\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"lint\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"outputs\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " []"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        }), _jsxs(_components.p, {
          children: ["일부 Vite 스타터는 다음과 같은 ", _jsx(_components.code, {
            children: "package.json"
          }), "과 함께 제공됩니다:"]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"scripts\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"tsc && vite build\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        }), _jsxs(_components.p, {
          children: ["이를 ", _jsx(_components.code, {
            children: "lint"
          }), " 및 ", _jsx(_components.code, {
            children: "build"
          }), " 스크립트로 분할하는 것이 좋습니다."]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"scripts\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"vite build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"lint\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"tsc\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        }), _jsxs(_components.p, {
          children: ["이렇게 하면 ", _jsx(_components.code, {
            children: "turbo"
          }), "가 별도로 스케줄링할 수 있습니다."]
        })]
      })]
    }), "\n", _jsxs(_components.ol, {
      start: "3",
      children: ["\n", _jsx(_components.li, {
        children: _jsxs(_components.strong, {
          children: [_jsx(_components.code, {
            children: "turbo"
          }), "로 ", _jsx(_components.code, {
            children: "build"
          }), " 및 ", _jsx(_components.code, {
            children: "lint"
          }), " 실행 시도:"]
        })
      }), "\n"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " lint"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["축하합니다 - ", _jsxs(_components.strong, {
        children: [_jsx(_components.code, {
          children: "turbo"
        }), "로 첫 번째 빌드를 실행했습니다"]
      }), ". 다음을 시도할 수 있습니다:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["전체 ", _jsx(_components.a, {
          href: "/docs",
          children: "빠른 시작"
        }), "을 실행합니다."]
      }), "\n", _jsxs(_components.li, {
        children: ["Turborepo를 특별하게 만드는 요소를 이해하려면 업데이트된 ", _jsx(_components.a, {
          href: "/docs/crafting-your-repository/caching",
          children: "핵심 개념 문서"
        }), "를 확인하세요."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "언제-turborepo를-사용해야-하나요",
      children: "언제 Turborepo를 사용해야 하나요?"
    }), "\n", _jsx(_components.p, {
      children: "모노레포가 아닌 환경에서 Turborepo를 사용할 수 있게 되면서 많은 새로운 사용 사례가 열렸습니다. 그러나 언제 가장 좋을까요?"
    }), "\n", _jsx(_components.h3, {
      id: "스크립트가-서로-의존할-때",
      children: "스크립트가 서로 의존할 때"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo"
      }), "를 사용하여 ", _jsx(_components.code, {
        children: "package.json"
      }), " 스크립트를 실행해야 합니다. 서로 의존하는 여러 스크립트가 있는 경우 Turborepo 작업으로 표현할 수 있습니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"pipeline\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"outputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"dist/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"lint\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "      // 'lint' 전에 'build'를 실행해야 합니다"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"test\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "      // 'test' 전에 'build'를 실행해야 합니다"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "그런 다음 다음을 실행할 수 있습니다:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " lint"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " test"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "lint"
      }), " 및 ", _jsx(_components.code, {
        children: "test"
      }), " 전에 ", _jsx(_components.code, {
        children: "build"
      }), "를 실행해야 한다고 말했기 때문에 ", _jsx(_components.code, {
        children: "lint"
      }), " 또는 ", _jsx(_components.code, {
        children: "test"
      }), "를 실행할 때 ", _jsxs(_components.em, {
        children: ["자동으로 ", _jsx(_components.code, {
          children: "build"
        }), "를 실행"]
      }), "합니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["뿐만 아니라 최적의 스케줄을 알아냅니다. ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/configuring-tasks",
        children: "속도 최적화"
      }), "에 대한 핵심 개념 문서를 참조하세요."]
    }), "\n", _jsx(_components.h3, {
      id: "작업을-병렬로-실행하려는-경우",
      children: "작업을 병렬로 실행하려는 경우"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://nextjs.org/",
        children: "Next.js"
      }), " 앱을 실행하고 ", _jsx(_components.a, {
        href: "https://tailwindcss.com/docs/installation",
        children: "Tailwind CLI"
      }), "도 실행한다고 상상해보세요. ", _jsx(_components.code, {
        children: "dev"
      }), " 및 ", _jsx(_components.code, {
        children: "dev:css"
      }), "라는 두 개의 스크립트가 있을 수 있습니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"scripts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"dev\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"next\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"dev:css\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"tailwindcss -i ./src/input.css -o ./dist/output.css --watch\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo.json"
      }), "에 아무것도 추가하지 않고도 다음을 실행할 수 있습니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " dev"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " dev:css"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://www.npmjs.com/package/concurrently",
        children: _jsx(_components.code, {
          children: "concurrently"
        })
      }), "와 같은 도구처럼 Turborepo는 자동으로 두 스크립트를 병렬로 실행합니다."]
    }), "\n", _jsx(_components.p, {
      children: "이것은 개발 모드에 매우 유용하지만 CI에서 작업 속도를 높이는 데도 사용할 수 있습니다 - 실행할 여러 스크립트가 있다고 상상해보세요:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " lint"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " unit:test"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " e2e:test"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " integration:test"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "Turborepo는 모든 작업을 병렬로 실행하는 가장 빠른 방법을 알아냅니다."
    }), "\n", _jsx(_components.h2, {
      id: "npm에서-이제-prune-지원",
      children: "npm에서 이제 Prune 지원"
    }), "\n", _jsxs(_components.p, {
      children: ["지난 몇 번의 릴리스에 걸쳐 다양한 워크스페이스 관리자에서 ", _jsx(_components.a, {
        href: "/docs/reference/prune",
        children: _jsx(_components.code, {
          children: "turbo prune"
        })
      }), "에 대한 지원을 추가해 왔습니다. 이것은 어려운 작업이었습니다 - ", _jsx(_components.code, {
        children: "turbo prune"
      }), "은 lockfile의 종속성 프루닝을 포함하여 모노레포의 하위 집합을 만듭니다. 이는 각 워크스페이스 관리자에 대해 별도로 로직을 구현해야 함을 의미했습니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo prune"
      }), "이 이제 ", _jsx(_components.code, {
        children: "npm"
      }), "에서 작동한다는 것을 발표하게 되어 기쁩니다. 이로써 모든 주요 패키지 관리자에 대한 지원이 완료되었습니다. 즉, 모노레포가 ", _jsx(_components.code, {
        children: "npm"
      }), ", ", _jsx(_components.code, {
        children: "yarn"
      }), ", ", _jsx(_components.code, {
        children: "yarn 2+"
      }), " 또는 ", _jsx(_components.code, {
        children: "pnpm"
      }), "을 사용하는 경우 Docker에 쉽게 배포할 수 있습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["자세한 내용은 ", _jsxs(_components.a, {
        href: "/blog/turbo-0-4-0#experimental-pruned-workspaces",
        children: [_jsx(_components.code, {
          children: "turbo prune"
        }), "에 대한 이전 블로그"]
      }), "를 확인하세요."]
    }), "\n", _jsx(_components.h2, {
      id: "캐시의-성능-개선",
      children: "캐시의 성능 개선"
    }), "\n", _jsxs(_components.p, {
      children: ["1.6 이전에는 Turborepo의 로컬 캐시가 시스템의 파일을 디스크의 다른 위치로 재귀적으로 복사하는 방식이었습니다. 이것은 ", _jsx(_components.em, {
        children: "느렸습니다"
      }), ". 캐시해야 하는 모든 파일에 대해 6번의 시스템 호출을 수행해야 했습니다: 소스 파일에서 열기, 읽기 및 닫기; 대상 파일에서 열기, 쓰기 및 닫기."]
    }), "\n", _jsxs(_components.p, {
      children: ["1.6에서는 이를 거의 절반으로 줄였습니다. 이제 캐시를 만들 때 단일 ", _jsx(_components.code, {
        children: ".tar"
      }), " 파일(", _jsx(_components.em, {
        children: "하나의"
      }), " 열기)을 만들고, 1mb 청크로 쓰고(", _jsx(_components.em, {
        children: "배치"
      }), " 쓰기), 닫습니다(", _jsx(_components.em, {
        children: "하나의"
      }), " 닫기). 시스템 호출의 절반은 캐시에서 나오는 방식에서도 ", _jsx(_components.em, {
        children: "발생합니다"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["그리고 여기서 멈추지 않았습니다. 지난 한 달 동안 C로 작성된 최고 수준의 라이브러리 사용을 가능하게 하는 CGO를 활성화하기 위해 빌드 도구 체인에 상당한 투자를 했습니다. 이를 통해 압축을 위해 ", _jsx(_components.a, {
        href: "https://facebook.github.io/zstd/",
        children: "Zstandard"
      }), "의 ", _jsx(_components.code, {
        children: "libzstd"
      }), "를 채택할 수 있었으며, 이는 압축에 대한 알고리즘 3배 성능 향상을 제공합니다."]
    }), "\n", _jsx(_components.p, {
      children: "이러한 모든 변경 사항 이후 로컬 캐시 생성에서 2배 이상, 원격 캐시 생성에서 3배 이상의 성능 향상을 정기적으로 확인하고 있습니다. 이는 저장소가 클수록 또는 장치가 느릴수록(CI를 보고 있습니다) 더욱 좋아집니다. 이는 가장 필요로 하는 사람들에게 정확하게 성능 향상을 제공할 수 있었음을 의미합니다."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
